import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { ButtonContainer } from "../Shared/ButtonComponent";

import Successful from "../../Assets/Images/successful.png";
import Moment from "react-moment";
import { useEffect } from "react";

function LaundryOrders({ laundryOrders, setLaundryOrders, selectedOrder }) {
  const closeModalHandler = () => setLaundryOrders(false);
  const [laundryOrderSuccess, setLaundryOrderSuccess] = useState(false);
  const [itemCount, setItemCount] = useState();

  let c = [];
  selectedOrder?.laundry_type?.map((item) => {
    console.log(item);
    c.push(item.cloth_count);
  });

  useEffect(() => {
    let result = c.reduce((a, b) => {
      return a + b;
    }, 0);

    setItemCount(result);
  }, [selectedOrder]);

  console.log(itemCount);
  return (
    <div>
      <Modal
        dialogClassName={"OrdersModal"}
        show={laundryOrders}
        onHide={closeModalHandler}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal-title"
          ></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h2 className="ord_details">Order Details</h2>
          </div>
          <div className="Laundry-Orders">
            <div className="laundry-order-page on_laundry">
              <div>
                <img alt="img" src={selectedOrder?.image_url} />
              </div>

              <div>
                <p>{selectedOrder.service}</p>
                <p>
                  <Moment format="HH:mm">{selectedOrder?.created_at}</Moment> |{" "}
                  <Moment format="YYYY/MM">{selectedOrder?.created_at}</Moment>
                </p>
                <p>{selectedOrder.order_id}</p>

                <p className="laundry_option">
                  <span className="text-black">Status:{" "}</span>
                  {selectedOrder.status === 1
                    ? "Pickup"
                    : selectedOrder.status === 2
                    ? "Washing"
                    : "Completed"}
                </p>
              </div>
            </div>
            <div className="laundry_content">
              <div>
                <p>Items Qty</p>
                <p>{itemCount}</p>
              </div>
              <div>
                <p>Contact</p>
                <p>+{selectedOrder?.whatsapp_number}</p>
              </div>
              {/* <div>
                <p>Pick Up</p>
                <p>{selectedOrder?.pick_up_address}</p>
              </div> */}
              <div>
                <p>Delivery</p>
                <p>{selectedOrder?.delivery}</p>
              </div>
            </div>
            <div className="col-12 laundry_address">
              <div>
                <p>Delivery Address</p>
                <p>
                  {selectedOrder?.delivery_address === ""
                    ? "Nil"
                    : selectedOrder?.delivery_address}
                </p>
              </div>
              <div>
                <p>Fabric Pickup Address</p>
                <p>Nil</p>
              </div>
            </div>
            <div className="laundrySummary-content laundry-ord">
              <div>
                <div>Services</div>
                <div>Rate</div>
                <div>Qty</div>
              </div>
              {selectedOrder?.laundry_type?.map((item, index) => (
                <div key={index}>
                  <div>
                    <div className="cloth_type ">{item.name}</div>
                    <div className="service_type text-capitalize">
                      {item.service_type}
                    </div>
                  </div>
                  <div>{item.price}</div>
                  <div>{item.cloth_count}</div>
                </div>
              ))}
            </div>
            <div className="col-12 laundrySummary-footer orderFooter">
              <div>
                <span>Subtotal:</span>
                <span>₦{selectedOrder?.total_price}</span>
              </div>
              <div>
                <span>Deliver fee:</span>
                <span>₦{selectedOrder?.delivery_fee}</span>
              </div>

              <div>
                <span>Total:</span>
                <span>
                  ₦{selectedOrder?.total_price + selectedOrder?.delivery_fee}
                </span>
              </div>
            </div>
          </div>

          {/* <ButtonContainer
            onClick={() => {
              setLaundryOrderSuccess(true);
              setLaundryOrders(false);
              updateStatus();
            }}
            className={
              selectedOrder.status === "Delivered" &&
              "disabled complete-disabled"
            }
          >
            Confirm Order Received
          </ButtonContainer> */}
        </Modal.Body>
      </Modal>
      <PaymentSuccessful {...{ laundryOrderSuccess, setLaundryOrderSuccess }} />
    </div>
  );
}

export default LaundryOrders;

const PaymentSuccessful = ({ laundryOrderSuccess, setLaundryOrderSuccess }) => {
  const closeModalHandler = () => setLaundryOrderSuccess(false);

  return (
    <Modal
      show={laundryOrderSuccess}
      onHide={closeModalHandler}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="payment_success order-success">
          <img alt="img" src={Successful} />
          <h2>
            <strong>Order Confirmation Successful</strong>
          </h2>
          <h5>Your order has successfully been confirmed</h5>
          <ButtonContainer
            onClick={() => {
              setLaundryOrderSuccess(false);
            }}
          >
            Done
          </ButtonContainer>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {/* <Button onClick={props.onHide}>Close</Button> */}
      </Modal.Footer>
    </Modal>
  );
};
